import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SerializedMessage {
  id: string;
  text: string;
  user: string;
  created_at: string | null;
}

export interface ChatChannel {
  id: string;
  name: string;
  memberId: string;
  memberName: string;
  providerId: string;
  providerName: string;
  providerRole: 'doctor' | 'nutritionist' | 'support';
  unreadCount: number;
  lastMessage?: SerializedMessage | null;
}

interface ChatState {
  channels: ChatChannel[];
  unreadCount: number;
  currentChannelId: string | null;
  isLoading: boolean;
}

const initialState: ChatState = {
  channels: [],
  unreadCount: 0,
  currentChannelId: null,
  isLoading: false,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setChannels(state, action: PayloadAction<ChatChannel[]>) {
      state.channels = action.payload;
    },
    addChannel(state, action: PayloadAction<ChatChannel>) {
      const existingIndex = state.channels.findIndex((ch) => ch.id === action.payload.id);
      if (existingIndex >= 0) {
        state.channels[existingIndex] = action.payload;
      } else {
        state.channels.push(action.payload);
      }
    },
    setCurrentChannel(state, action: PayloadAction<string | null>) {
      state.currentChannelId = action.payload;
    },
    updateUnreadCount(state) {
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setTotalUnreadCount(state, action: PayloadAction<number>) {
      state.unreadCount = action.payload;
    },
  },
});

export const { setChannels, addChannel, setCurrentChannel, updateUnreadCount, setLoading, setTotalUnreadCount } =
  chatSlice.actions;
export default chatSlice.reducer;

